import { useHistory } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
// Our Components
import { useResize } from 'Hooks/useResize';
// Utils and Helpers
import { APP_ROUTES } from 'routes';
// Assets
import EmailSended from 'assets/authentication/emailSend.svg';
import PaystandLogo from 'assets/authentication/PSLogow.svg';
import './MessageRecovery.css';

const MessageRecovery = () => {
    const history = useHistory();
    const { screenWidth } = useResize();

    return (
        <Box id="message-recovery-section">
            <Box>
                <Box display="flex" justifyContent="center">
                    <img className="paystand-logo" src={PaystandLogo} alt="paystand-logo" />
                </Box>
                <Box className="message-recovery-card">
                    <Box>
                        <img src={EmailSended} alt={'email-sended'} />
                    </Box>
                    <Box
                        sx={{
                            fontSize: '23px',
                            fontWeight: 'bold',
                            marginTop: '32px'
                        }}>
                        Recovery Email Sent!
                    </Box>
                    <Box marginTop="1em" sx={{ width: screenWidth > 500 ? '430px' : '95%' }} textAlign="center">
                        <Typography variant="subtitle1" sx={{ color: '#7D95A5' }}>
                            Please check your email for next steps to reset your password. If you can't see the email, it might be
                            in your spam folder, or your Virtual Card account might be under a different email address.
                        </Typography>
                    </Box>
                    <Box marginTop="24px">
                        <Button
                            variant="contained"
                            className="btn-rounded"
                            sx={{
                                width: '200px'
                            }}
                            onClick={() => history.push(APP_ROUTES.LOGIN)}>
                            Back to Log In
                        </Button>
                    </Box>
                    <Box marginTop="60px" display="flex" justifyContent="center">
                        <Typography variant="caption">© Paystand, Inc, 2020. All Rights Reserved.</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default MessageRecovery;
